import { NgModule } from '@angular/core';
import { ChatListComponent } from './chat-list/chat-list.component';
import { SharedModule } from '../shared/shared.module';
import { ChatModule } from '@progress/kendo-angular-conversational-ui';
import { ChatHistoryComponent } from './chat-history/chat-history.component';
import { ChatUserSelectionComponent } from './chat-user-selection/chat-user-selection.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ChatWindowComponent } from './chat-window/chat-window.component';
import { WindowModule } from '@progress/kendo-angular-dialog';

@NgModule({
  imports: [
    SharedModule,
    ChatModule,
    NgbModule,
    IconsModule,
    WindowModule
  ],
  declarations: [
    ChatListComponent,
    ChatHistoryComponent,
    ChatUserSelectionComponent,
    ChatWindowComponent
  ],
  exports: [
    ChatListComponent,
    ChatHistoryComponent,
    ChatUserSelectionComponent,
    ChatWindowComponent
  ]
})
export class ChannelsChatModule { }
